import { Box } from '@mui/material';
import { CustomScroll } from 'react-custom-scroll';
import { useSelector } from 'react-redux';
import { SimpleNode } from '../../../models/models';
import { selectNodeSelected } from '../../../store/node/node.selector';
import { getNodeTypeLabel } from '../../../utils/data/data.utils';
import NodeButton from '../../button-node-status/node-button';
import NodeButtonReopen from '../../button-node-status/node-button-return';
import NodeAccordionDetailsDocumentsGrid from './node-accordion-details-documents-grid/node-accordion-details-documents-grid.component';
import NodeAccordionDetailsModels3dGrid from './node-accordion-details-models-3d-models-grid/node-accordion-details-models-3d-models-grid.component';
import NodeAccordionDetailsScenes3dGrid from './node-accordion-details-scenes-3d-grid/node-accordion-details-scenes-3d-grid.component';
import {
    CustomAccordionDetails,
    CustomAccordionDetailsDescriptionText,
    CustomAccordionDetailsDivider,
    CustomAccordionDetailsTitleText,
} from './node-accordion-details.styles';

const NodeAccordionDetails = ({ node }: { node: SimpleNode }) => {
    const nodeSelected = useSelector(selectNodeSelected);

    return (
        <CustomAccordionDetails>
            {nodeSelected && (
                <Box
                    height={1}
                    ml={2}
                    display={'flex'}
                    flexDirection={'column'}
                    justifyContent={'space-between'}
                >
                    <CustomScroll
                        heightRelativeToParent="100%"
                        className="custom-scroll"
                    >
                        <Box paddingRight={'10px'}>
                            <CustomAccordionDetailsTitleText>
                                {`DESCRIZIONE ${getNodeTypeLabel(
                                    node.type
                                )}`.toUpperCase()}
                            </CustomAccordionDetailsTitleText>
                            <Box my={1} />
                            <CustomAccordionDetailsDescriptionText>
                                {nodeSelected.description}
                            </CustomAccordionDetailsDescriptionText>
                            <Box my={3} />
                            <NodeAccordionDetailsDocumentsGrid />
                            <Box my={1} />
                            <CustomAccordionDetailsDivider />
                            <Box mt={3} />
                            <NodeAccordionDetailsModels3dGrid />
                            <Box my={1} />
                            <CustomAccordionDetailsDivider />
                            <Box my={3} />
                            <NodeAccordionDetailsScenes3dGrid />
                            <Box mt={4} />
                        </Box>
                    </CustomScroll>
                    {nodeSelected!.can_be_reviewed && (
                        <Box
                            display="flex"
                            justifyContent={'flex-end'}
                            gap={2}
                            pt={2}
                        >
                            <NodeButtonReopen node={nodeSelected} />
                            <NodeButton node={nodeSelected} />
                        </Box>
                    )}
                </Box>
            )}
        </CustomAccordionDetails>
    );
};

export default NodeAccordionDetails;
